module.exports = __webpack_public_path__ + "img/icon_goals.142dc865.svg";